import React from 'react';

import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';

import '../css/modal-header-v2.less';

class ModalHeaderV2 extends React.PureComponent {
	render() {
        const { productInfo, className } = this.props;
        const { name, imageUrl, ksps, salePrice } = productInfo;
 
		return (
            <div className={`modal-header-v2${className ? ' ' + className : ''}`}>
                <ImageWithPlaceholder src={imageUrl} className='modal-header-img' />
                <div className='prod-info'>
                <h3 className='prod-title'>{name}</h3>
                <div className='ksps'>
                    {ksps.map((ksp) => (
                        <span key={ksp}>{ksp}</span>
                    ))}
                </div>
                <span className='price'>{`$${salePrice}`}</span>
                </div>
            </div>
		)
	}
}

export default ModalHeaderV2;